import { useState } from 'react';

import { RedirectContext } from './redirect-context';

interface RedirectProviderProps {
  children: React.ReactNode;
}

const RedirectProvider: React.FC<RedirectProviderProps> = ({ children }) => {
  const [redirectToUrlAfterLogin, setRedirectToUrlAfterLogin] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string>();

  return (
    <RedirectContext.Provider
      value={{
        redirectToUrlAfterLogin,
        redirectTo,
        setRedirectToUrlAfterLogin,
        setRedirectTo,
      }}
    >
      {children}
    </RedirectContext.Provider>
  );
};

export default RedirectProvider;
